<div class="container">
  <ion-searchbar
    [placeholder]="'machinery.search' | translate"
    show-clear-button="focus"
    (ionInput)="handleSearchInput($event)"
  ></ion-searchbar>
  <div class="custom-table">
    <div class="row header">
      <div class="col" style="display: flex; align-items: center">
        {{ "machinery.inventoryNumberShort" | translate }}
        <ion-icon
          size="small"
          style="color: black; cursor: default"
          name="caret-up-outline"
        ></ion-icon>
      </div>
      <div class="col grow" style="display: flex; align-items: center">
        {{ "common.name" | translate }}
      </div>

      <div class="col">{{ "machinery.category" | translate }}</div>
      <div class="col">{{ "common.status" | translate }}</div>
    </div>

    @for (wd of filteredEntries; track wd) {
    <div class="row" (click)="openDetailModal(wd.id)">
      <div class="col grow">{{ wd.inventoryNumber }}</div>
      <div class="col">{{ wd.manufacturer }} {{ wd.type }}</div>
      <div class="col grow">{{ wd.category }}</div>
      <div class="col grow centered">
        @if(wd.inspectionNecessary){
        <ion-icon
          style="font-size: 20px"
          class="red"
          name="close-circle-outline"
        ></ion-icon>
        } @if(!wd.inspectionNecessary && (wd.nextManualInspection != null ||
        !wd.inspectionFree)){
        <ion-icon
          style="font-size: 20px"
          class="green"
          name="checkmark-circle-outline"
        ></ion-icon>
        } @if(wd.daysUntilNextInspection !== null && !wd.inspectionFree){ ({{
          wd.daysUntilNextInspection
        }})}
      </div>
    </div>
    }
  </div>
  <lib-table-legend [items]="[4, 5]"></lib-table-legend>
</div>
